import React, { FC, useContext } from 'react';
import { TooltipTip } from '../../../../../../../ReactSharedScripts/components/Tooltip';
import CheckboxGroup from '../../../../../../../ReactSharedScripts/components/CheckboxGroup';
import Button from '../../../../../../../ReactSharedScripts/components/Button';
import classes from '../columnSwitcherStyles/index.module.scss';
import { codes } from '../../../../../../../ReactSharedScripts/data/translations';
import { TranslationContext } from '../../../../../../../ReactSharedScripts/modules/translations';
import { MultiSelectProviderAPI } from '../../../../../../../ReactSharedScripts/components/MultiSelectProvider/types';
import { CheckboxItem } from '../../../../../../../ReactSharedScripts/components/CheckboxGroup/types';

type SpreadsheetColumnSwitcherTooltipProps = {
	tooltipColumns: Array<CheckboxItem>;
	onApplyButtonClick: () => void;
} & Pick<MultiSelectProviderAPI, 'onTempChange'>;

const SpreadsheetColumnSwitcherTooltip: FC<SpreadsheetColumnSwitcherTooltipProps> = ({
	tooltipColumns,
	onTempChange,
	onApplyButtonClick,
}) => {
	const { translate } = useContext(TranslationContext);

	return (
		<TooltipTip className={classes.columnSwitcherTooltip}>
			<CheckboxGroup
				items={tooltipColumns}
				arrangement='vertically'
				onIndicatorToggle={onTempChange}
			/>
			<Button
				className={classes.tooltipApplyButton}
				link
				onClick={onApplyButtonClick}
			>
				{translate(codes.apply)}
			</Button>
		</TooltipTip>
	);
};

export default SpreadsheetColumnSwitcherTooltip;
